// src/utils/withRouter.js
import React, { useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import SessionManager from './sessionManager';

export function withRouter(Component) {
  function ComponentWithRouterProps(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const resolvedLocation = useMemo(() => {
      const shouldRestoreResultsState =
        location.pathname.includes('QuoteResults');

      if (!shouldRestoreResultsState) {
        return location;
      }

      return {
        ...location,
        state: {
          ...(location.state || {}),
          formValues:
            location.state?.formValues ?? SessionManager.getFormValues() ?? {},
        },
      };
    }, [location]);

    return (
      <Component
        {...props}
        location={resolvedLocation}
        navigate={navigate}
        params={params}
      />
    );
  }

  return ComponentWithRouterProps;
}

export default withRouter;
